// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.

export const StatsSvparam = {
  TYPE_SV_DELETION: "Deletion",
	TYPE_SV_INSERTION: "Insertion",
	TYPE_SV_INVERSION: "Inversion",
	TYPE_SV_INDEL: "InDel",
	TYPE_SV_TRANSLOCATION: "Translocation",
	TYPE_SV_DUPLICATION: "Duplication",
	TYPE_SV_INTER_TRANSLOCATION: "InterchromosomalTranslocation",
	TYPE_SV_INTRA_TRANSLOCATION: "IntrachromosomalTranslocation",
  TYPE_SV_VALUE_TOTAL: "__TOTAL__",
	PIE_CHART_CHOICE_DEFAULT: "__ALL__",
	PIE_CHART_VALUE_TOTAL: "__TOTAL__",
	PIE_CHART_COLORS: "__COLOR__",
	COL_SV_DELETION: "rgb(192,80,77)",
	COL_SV_INSERTION: "rgb(79,129,189)",
	COL_SV_INVERSION: "rgb(155,187,89)",
	COL_SV_INDEL: "rgb(255,153,50)",
	COL_SV_TRANSLOCATION: "rgb(162,40,255)",
	COL_SV_DUPLICATION: "rgb(116,192,242)",
	COL_SV_OTHER: "rgb(221,221,221)",
};

export const StatsSvChromosomeColumns = {
  CHR: "chr",
  COL1: "col1",
  COL2: "col2",
  COL3: "col3",
  COL4: "col4",
  COL5: "col5",
  COL6: "col6",
  COL7: "col7",
  COL8: "col8",
  COL9: "col9",
  COL10: "col10",
  COL11: "col11",
  COL12: "col12",
  COL13: "col13",
  COL14: "col14",
};

export const StatsMessage = {
  ERROR_HEADER: "SVreport_parse Error : ",
  WARN_HEADER: "SVreport_parse Warning : ",
  ERROR_REFSNAMETABLE: 'Please set Reference Name Mapping file.',
}
